export enum ChangeControlPhase{
    Collaboration=0,
    InReview=1,
    ReadyForApproval=2,
    Implementation=3,
    Verification=4,
    Complete=5
}